/** User-facing labels for commissions (API routes unchanged). */

export const COMMISSIONS_CALCULATE_LABEL = 'Calculate';

export const COMMISSIONS_PAID_LABEL = 'Paid';
